export const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NUMBER_ONLY_REGEXP = /^\d+$/;
export const SEPARATORS_REGEXP = /\s*(?:[,;" "/\n/]|$)\s*/;
export const COVER_MAX_SIZE = 2000000;
export const DOMAIN_REGEXP = /((?:[a-z\d](?:[a-z\d-]{0,63}[a-z\d])?|\*)\.)+[a-z\d][a-z\d-]{0,63}[a-z\d]/;
export const SENDER_REGEXP = /^[A-Za-z0-9_-]+$/;